function triggleChatWidget(event, ele){
  if(typeof zE == 'function'){
    event.preventDefault();
    zE('webWidget', 'open');    
    if(ele.closest('header-drawer')){
      setTimeout(()=>{        
        ele.closest('header-drawer').querySelector('details.menu-drawer-container>summary').dispatchEvent(new Event('click', { bubbles: true }));        
        ele.closest('.toggle-open') && (
          ele.closest('.toggle-open').querySelector('.toggle-open-align').dispatchEvent(new Event('click', { bubbles: true }))
        );
      }, 1000)
    }else if( ele.closest('.help-support-menu') ){
      ele.closest('.help-support-menu').style.display = 'none'
    }    
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".rec-swiper", {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".recommendations-product .swiper-button-next",
      prevEl: ".recommendations-product .swiper-button-prev",
    },
    breakpoints: {
      767: {
        navigation: {
          nextEl: ".recommendation-reviews .swiper-button-next",
          prevEl: ".recommendation-reviews .swiper-button-prev",
        },
      },
    },
  });
});

// pdp buy set and save slider -->set template 
 var swiper = new Swiper(".buy_set_save", {
  slidesPerView: 1,
  spaceBetween: 30,
  loop: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".buy_in_set_arrow.swiper-button-next",
    prevEl: ".buy_in_set_arrow.swiper-button-prev",
  },
});

// pdp about the set dropdopdown -->set template
 document.addEventListener('DOMContentLoaded', function () {
  const arrows = document.querySelectorAll('.short_desc_arrow, .short_descrption_main');
  const drop_downs_about = document.querySelectorAll('.about_ref_products .product-inner');

  arrows.forEach(function (arrow) {
    arrow.addEventListener('click', function (event) {

      // Toggle active on arrow
      arrow.classList.toggle('active');
      arrow.querySelector('.short_desc_arrow') && (
        arrow.querySelector('.short_desc_arrow').classList.toggle('active'),
        event.preventDefault()
      )

      if(arrow.classList.contains('short_descrption_main') && arrow.closest('.product-content')){
        arrow.closest('.product-content').querySelector('.short_desc_arrow').classList.toggle('active');
      }

      // Get the closest .short_descrption_main
      const container = arrow.closest('.short_descrption_main');

      // Get the .about_ref_prod_desc (next sibling of container's parent)
      const desc = container?.parentElement?.querySelector('.about_ref_prod_desc');

      if (desc) {
        desc.classList.toggle('active');
      }

      // Get the closest .product-content wrapper and toggle active
      const productContent = arrow.closest('.about-list');
      if (productContent) {
        productContent.classList.toggle('active');
        if( window.innerWidth < 750 && productContent.classList.contains('active') ){
          productContent.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
        }
      }
    });
  });

  drop_downs_about.forEach((dropTitle) => {
    dropTitle.addEventListener('click', function (event) {
      event.preventDefault();
      if(dropTitle.closest('.product-content').querySelector('.short_descrption_main')){
        dropTitle.closest('.product-content').querySelector('.short_descrption_main').click();
      }
    })
  })
});




// pdp slideout pdp-slide-about -->>set template template
  document.addEventListener("DOMContentLoaded", function () {
    const trigger = document.querySelector(".find-about-link");
    //const trigger2 = document.querySelectorAll(".product-data");
    //const trigger2 = document.querySelectorAll(".product__media-wrapper .product-data");
    const panel = document.getElementById("pdpSlideout-about");
    const closeBtn = document.getElementById("pdpClose-abouts");

    // trigger2.forEach((aboutBtns)=>{
    //   aboutBtns.addEventListener("click", () => {
    //     panel.classList.add("open");
    //     document.body.classList.add("overlay-added");
    //   });
    // })

    if (trigger && panel && closeBtn) {
      trigger.addEventListener("click", () => {
        panel.classList.add("open");
        document.body.classList.add("overlay-added");
      });

      closeBtn.addEventListener("click", () => {
        panel.classList.remove("open");
        document.body.classList.remove("overlay-added");
      });

      // Optional: close when clicking outside the panel
      document.addEventListener("click", (e) => {
        if(!document.body.classList.contains('sets-products') && !panel.getAttribute('id') == 'pdpSlideout-about'){
          if (!panel.contains(e.target) && !trigger.contains(e.target)) {
            if(!e.target.classList.contains('product-data')){
              panel.classList.remove("open");
              document.body.classList.remove("overlay-added");
            }
          }
        }
        
      });
    }
  });

// pdp slideout pdp-slide-recommended --> set template
  document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".pdp-slide-recommended-set");
  var panel = document.getElementById("pdpSlideout-rec-set");
  const closeBtn = document.getElementById("pdpClose-rec-set");
  //const panel2 = document.getElementById("pdpSlideout-about");
  const productDataElements = document.querySelectorAll(".product__media-wrapper .product-data");

  if (trigger && panel && closeBtn) {
    // Open panel on trigger click
    trigger.addEventListener("click", () => {
      panel.classList.add("open");
    });

    // Open panel on .product-data click
    productDataElements.forEach((el) => {
      el.addEventListener("click", () => {
        //console.log('ininin',panel2);
        panel.classList.add("open");
        console.log('ininin',panel);
        //document.getElementById("pdpSlideout-about").classList.add("open");
      });
    });

    // Close panel on close button click
    closeBtn.addEventListener("click", () => {
      panel.classList.remove("open");
    });

    // Optional: close when clicking outside the panel
    document.addEventListener("click", (e) => {
      if (
        // !panel.contains(e.target) &&
        // !trigger.contains(e.target) &&
        // ![...productDataElements].some(el => el.contains(e.target))
        !panel.contains(e.target) &&
        !trigger.contains(e.target)
      ) {
        if(!e.target.classList.contains('product-data')){
          panel.classList.remove("open");
        }
      }
    });
  }
});

// pdp slideout pdp-set-slide-ingrident --------->>set template ingrident slideout
document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".pdp-set-slide-ingrident");
  const panel = document.getElementById("pdpSlideout-ing-set");
  const closeBtn = document.getElementById("pdpClose-about");

  if (trigger && panel && closeBtn) {
    trigger.addEventListener("click", () => {
      panel.classList.add("open");
    });

    closeBtn.addEventListener("click", () => {
      panel.classList.remove("open");
    });

    // Optional: close when clicking outside the panel
    document.addEventListener("click", (e) => {
      if (!panel.contains(e.target) && !trigger.contains(e.target)) {
        panel.classList.remove("open");
      }
    });
  }
});



// pdp slideout pdp-slide-ingrident -->Default template
  document.addEventListener("DOMContentLoaded", function () {
    const trigger = document.querySelector(".pdp-slide-ingrident");
    const panel = document.getElementById("pdpSlideout-ing");
    const closeBtn = document.getElementById("pdpClose");

    if (trigger && panel && closeBtn) {
      trigger.addEventListener("click", () => {
        panel.classList.add("open");
      });

      closeBtn.addEventListener("click", () => {
        panel.classList.remove("open");
      });

      // Optional: close when clicking outside the panel
      document.addEventListener("click", (e) => {
        if (!panel.contains(e.target) && !trigger.contains(e.target)) {
          panel.classList.remove("open");
        }
      });
    }
  });

// pdp slideout pdp-slide-recommended --> Default template
  document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".pdp-slide-recommended");
  const panel = document.getElementById("pdpSlideout-rec");
  const closeBtn = document.getElementById("pdpClose-rec");
  const productDataElements = document.querySelectorAll(".product__media-wrapper .product-data");

  if (trigger && panel && closeBtn) {
    // Open panel on trigger click
    trigger.addEventListener("click", () => {
      panel.classList.add("open");
    });

    // Open panel on .product-data click
    productDataElements.forEach((el) => {
      el.addEventListener("click", () => {
        panel.classList.add("open");
      });
    });

    // Close panel on close button click
    closeBtn.addEventListener("click", () => {
      panel.classList.remove("open");
    });

    // Optional: close when clicking outside the panel
    document.addEventListener("click", (e) => {
      if (
        !panel.contains(e.target) &&
        !trigger.contains(e.target) &&
        ![...productDataElements].some(el => el.contains(e.target))
      ) {
        panel.classList.remove("open");
      }
    });
  }
});

 




// covet Instagram slide overwrite script 


document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('galleryReady:covetPics', function () {
    const covetPicsWidget = document.querySelector('covet-pics-widget');
    if (!covetPicsWidget || !covetPicsWidget.shadowRoot) return;

    function waitForElement(selector, root, callback) {
      const el = root.querySelector(selector);
      if (el) return callback(el);
      requestAnimationFrame(() => waitForElement(selector, root, callback));
    }

    waitForElement('.gallery.swiper', covetPicsWidget.shadowRoot, (covetPicsWidgetSwiper) => {
      setTimeout(function(){
        // Inject styles
        const styleTag = document.createElement('style');
        styleTag.textContent = `
          covet-pics-gallery-slider.pagination-bottom { --covet-slider-padding-bottom: 0; padding-bottom: 40px !important; }
          covet-pics-gallery-slider .swiper-pagination { display: none; }
          .swiper-pagination-bullet {
            width: 12px !important;
            height: 12px !important;
            background: #F2F7F5 !important
            opacity: 1 !important;
          }
          .swiper-pagination-bullet.swiper-pagination-bullet-active-main {
            background: #02643C !important;
            opacity: 1 !important;
          }
          covet-pics-gallery-slider .swiper-pagination.swiper-pagination-bullets-dynamic.bottom.center {
            width: 100% !important;
            height: 20px;
            align-items: center;
          }
          covet-pics-gallery-slider .swiper-pagination.swiper-pagination-bullets-dynamic.bottom.center {
            display: flex;
            justify-content: center;
            width: 100%;
            gap: 8px !important;
          }
          covet-pics-gallery-item:hover .bg,
          covet-pics-gallery-item:active .bg,
          covet-pics-gallery-item:focus .bg {
            transition: all 0.35s cubic-bezier(0.39, 0.575, 0.565, 1);
          }
          covet-pics-gallery-slider .swiper-button-prev,
          covet-pics-gallery-slider .swiper-button-next {
            visibility: hidden;
          }
          covet-pics-gallery-item .bg {          
            border-radius: 2.5rem;
          }        
        `;
        covetPicsWidget.shadowRoot.appendChild(styleTag);

        // Select pagination inside shadow DOM
        const paginationEl = covetPicsWidget.shadowRoot.querySelector('.swiper-pagination');

        // Destroy existing instance if exists
        if (covetPicsWidgetSwiper.swiper) {
          covetPicsWidgetSwiper.swiper.destroy(true, true);
        }

        const swiper = new Swiper(covetPicsWidgetSwiper, {
          slidesPerView: 1.49,
          spaceBetween: 10,
          initialSlide: 0,
          loop: true,
          pagination: {
            el: paginationEl,
            clickable: true,
            dynamicBullets: true,
          },
          navigation: {
            nextEl: '.insta-title .swiper-button-next',
            prevEl: '.insta-title .swiper-button-prev',
          },
          breakpoints: {
            320: {
              slidesPerView: 1.25,
              spaceBetween: 10,
            },
            750: {
              slidesPerView: 2.25,
            },
            990: {
              slidesPerView: 4,
            },
            1199: {
              slidesPerView: 6,
            },
            1550: {
              slidesPerView: 6,
            }
          },
          on: {
            slideChange: () => {
              // Optional: log or do something on slide change
              // console.log("Slide changed to", swiper.activeIndex);
            }
          }
        });

        // Initial slide positioning
        if (window.innerWidth > 1550) {
          swiper.slideTo(1);
        } else if (window.innerWidth > 991 && window.innerWidth < 749) {
          swiper.slideTo(1);
        }
      }, 800)
    });
  });
});


// product modal

$(".Click-here").on('click', function() {
    $(".custom-model-main").addClass('model-open');
  }); 
  $(".close-btn, .bg-overlay").click(function(){
    $(".custom-model-main").removeClass('model-open');
  });
  
  // announcement
  
  // mobile only slider grid layout
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth <= 768) {
      var swiper = new Swiper('.custom-swipe-mobile', {
        slidesPerView: 1,    // You can adjust how many slides you want to show
        spaceBetween: 10,
         navigation: {
          nextEl: ".swiper-ann-btn-next",
          prevEl: ".swiper-ann-btn-prev",
        },
      });
    }
  });
  
  // Check if there are more than 1 slide
  window.addEventListener('load', function() {
    var slideCount = document.querySelectorAll('.announcement_sliers .swiper-slide').length;
  
    if (slideCount > 1) {
      setNavArrowPosition('',document.querySelector('.announcement_sliers'));
      let d_speed = 1000, m_speed = 600;
      const d_speed_attr = document.querySelector('.announcement_sliers').dataset.speed,
      m_speed_attr = document.querySelector('.announcement_sliers').dataset.speedMobile
      d_speed_attr != null && (d_speed = Number(d_speed_attr));
      m_speed_attr != null && (m_speed = Number(m_speed_attr));
      var swiper = new Swiper(".announcement_sliers", {
        slidesPerView: 'auto',
        spaceBetween: 0,        
        loop: true,
        speed: m_speed,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        // cssMode: true,
        // centeredSlides: true,
        navigation: {
          nextEl: ".swiper-ann-btn-next",
          prevEl: ".swiper-ann-btn-prev",
        },
        breakpoints: {          
          0: {
            slidesPerView: 1,
            centeredSlides: true,
          },
          750: {
            slidesPerView: 'auto',
            centeredSlides: false,
            speed: d_speed,
          },
        },
        on: {
          init: function (swiper) {
            console.log('announcement_sliers swiper initialized');
            setNavArrowPosition(swiper);
          },
          slideChangeTransitionStart: function (swiper) {                        
            setNavArrowPosition(swiper);            
          },
        },
      });
    } else {
      // Hide arrows if there's only one slide
      document.querySelector('.swiper-ann-btn-prev').style.display = 'none';
      document.querySelector('.swiper-ann-btn-next').style.display = 'none';
    }
  });

  
    function setNavArrowPosition(swiper, element = null){      
        if( swiper?.el?.querySelector('.swiper-slide-active .announcement-msg') && window.innerWidth > 749 ){
          let offsetLeft = swiper.el.querySelector('.swiper-slide-active .announcement-msg').offsetLeft;      
          swiper.el.querySelector('.swiper-ann-btn-prev').style.left = offsetLeft+'px';
          swiper.el.querySelector('.swiper-ann-btn-next').style.right = offsetLeft+'px';
        } else if (element && element.querySelectorAll('.swiper-slide').length > 1 && window.innerWidth > 749){          
          setTimeout(() => {            
            let offsetLeft = element.querySelectorAll('.swiper-slide')[0].querySelector('.announcement-msg').offsetLeft;
            element.querySelector('.swiper-ann-btn-prev').style.left = offsetLeft - 20 +'px';
            element.querySelector('.swiper-ann-btn-next').style.right = offsetLeft - 20 +'px';            
          }, 610);
        } else{
          if( swiper.el ){
            swiper.el.querySelector('.swiper-ann-btn-prev').style.left = '';
            swiper.el.querySelector('.swiper-ann-btn-next').style.right = '';
          }
        }
    }
  
   
  // end announcement
  
  // index hero-layout2-slide inner
    var swiperNew = new Swiper(".hero-slide-inner", {
      slidesPerView: 1,
      loop: true,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true, 
      },
    });
  // footer mobile menu start 
  
  $(document).ready(function(){
  function handleMobileMenu() {
    if ($(window).width() <= 768) {
      
      $(".ab-footer-linklist").hide();
      $(".ab-icon-arrow").off('click').on('click', function(){
        
        var menu = $(this).closest('.footer-menu-block').find('.ab-footer-linklist');
  
        
        if(menu.is(':visible')){
          menu.slideUp();
          $(this).removeClass('rotate-arrow'); 
        } 
        
        else {
          $(".ab-footer-linklist").slideUp(); 
          $(".ab-icon-arrow").removeClass('rotate-arrow'); 
          menu.slideDown(); 
          $(this).addClass('rotate-arrow'); 
        }
  
        $("body").toggleClass("active-menu", menu.is(':visible'));
      });
    } else {
      
      $(".ab-footer-linklist").show(); 
      $(".ab-icon-arrow").removeClass('rotate-arrow'); 
    }
  }
  handleMobileMenu();
  
  $(window).resize(function(){
    handleMobileMenu();
  });
  });
  
  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('galleryReady:covetPics', function(e) {
      /*// prepare CSS styles to inject*/
      const stylesPopup = document.createElement('style')
      stylesPopup.innerHTML = `
        covet-pics-gallery-slider section.gallery .swiper-pagination.dots { display: none; }
      `;
      /*// get Covet gallery elements where you want to inject CSS (for eg. covet-pics-widget, covet-pics-popup, covet-pics-upload)*/
      const popup = document.querySelector("covet-pics-widget");
  
      /*// now inject CSS code into shadow DOM*/
      popup.shadowRoot.appendChild(stylesPopup);
     
      popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.centeredSlides = true;
      stylesPopup.innerHTML = `
        covet-pics-gallery-slider section.gallery .swiper-pagination.dots { display: none; }
      `;
      /*if (window.innerWidth < 750) {
        popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.slidesPerView = 1.7342;      
        popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.initialSlide = 1;
        popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.spaceBetween = 10;
      } else { }*/
        var breakPointObj = popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.breakpoints;
        breakPointObj[1551] = {
          slidesPerView: 6.32,
          spaceBetween: 15
        };
        breakPointObj[1200] = {
          slidesPerView: 4.77,
          spaceBetween: 15
        };
        breakPointObj[800] = {     
          slidesPerView: 2.77,   
          spaceBetween: 15
        };
        breakPointObj[750] = breakPointObj[800];
        breakPointObj[0] = {        
          spaceBetween: 10,
          initialSlide: 1,
          slidesPerView: 1.7342
        };
        popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.breakpoints = breakPointObj;      
     
      popup.shadowRoot.querySelector('.gallery.swiper').swiper.update();
      if (window.innerWidth < 750) { popup.shadowRoot.querySelector('.gallery.swiper').swiper.slideTo(1); }else{
        if (window.innerWidth > 800) {
          popup.shadowRoot.querySelector('.gallery.swiper').swiper.slideTo(3);
        }else{
          popup.shadowRoot.querySelector('.gallery.swiper').swiper.slideTo(1);
        }
      }
    });
  });
  
  // footer mobile menu end 
  
  //EN FR store class add. 
  document.addEventListener("DOMContentLoaded", function () {
    const htmlTag = document.documentElement;
    if (htmlTag.lang === "en") {
      document.body.classList.add("store-en");
    } else if (htmlTag.lang === "fr") {
      document.body.classList.add("store-fr");
    }
  });

  function toggleClick(e){
    e.closest('div').classList.toggle('active');
  }

  function closeModalPopup(){
    if(document.querySelector('product-modal').hasAttribute('open')){
      document.querySelector('product-modal .product-media-modal__toggle').click();
    }
  }